import React from "react";

import {
    Box,
    Card,
    CardContent,
    CardMedia,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";

import CustomButton from "../../helper-components/input/CustomButton";
import { loginWithPassword } from "../../helper-functions/api/authQueries";
import { useLanguage } from "../../config/language/language";

export default function LoginPage(props) {
    const LANG = useLanguage();
    const [password, setPassword] = React.useState("");
    const [role, setRole] = React.useState("guest");
    const [loading, setLoading] = React.useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await loginWithPassword(props, password, role);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ maxWidth: 440, mx: "auto", mt: 4 }}>
            <Card elevation={3} sx={{ overflow: "hidden" }}>
                <CardMedia
                    component="img"
                    height="180"
                    image="/images/signin.jpeg"
                    alt="Home cocktail bar"
                    sx={{ objectFit: "cover" }}
                />
                <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
                        <Box component="img" src="/images/logo.png" alt="" sx={{ width: 40, height: 40 }} />
                        <Typography variant="h5">{LANG.LOGIN_TITLE}</Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {LANG.WEBSITE_SLOGAN}
                    </Typography>

                    <Box component="form" onSubmit={handleSubmit}>
                        <FormControl sx={{ mb: 2 }}>
                            <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
                                <FormControlLabel value="guest" control={<Radio />} label={LANG.LOGIN_GUEST} />
                                <FormControlLabel value="admin" control={<Radio />} label={LANG.LOGIN_ADMIN} />
                            </RadioGroup>
                        </FormControl>

                        <TextField
                            fullWidth
                            type="password"
                            label={LANG.LOGIN_PASSWORD_LABEL}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoFocus
                            sx={{ mb: 2 }}
                        />

                        <CustomButton
                            {...props}
                            title={LANG.LOGIN_SUBMIT}
                            type="submit"
                            variant="contained"
                            fullWidth
                            disabled={loading || !password}
                        />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}
